import styles from "./PlansSection.module.scss";
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import {useEffect, useState} from "react";
import {IPackage} from "../../../models/Package";
import SectionSubtitle from "../../../components/UI/SectionSubtitle/SectionSubtitle";
import PlanItem from "../../../components/PlanItem/PlanItem";
import {Link} from "react-router-dom";
import arrowRight from "../../../assets/images/icons/arrow-right-blue.svg";

const PlansSection = () => {
    const {t} = useTranslation();

    const {content} = useAppSelector(state => state.siteContentSlice);
    const {packages} = useAppSelector(state => state.packageSlice);

    const [plansItems, setPlansItems] = useState<IPackage[]>([]);

    useEffect(() => {
        if (content.plansItems && content.plansItems.length && packages.length) {
            const selectedPlanItems = content.plansItems;
            const selectedPlanItemsIds = content.plansItems.map(el => el.packageId);
            const changePackageItems = packages.filter(el => selectedPlanItemsIds.includes(el.id)).map(el => {
                return {
                    ...el,
                    description: selectedPlanItems.find(x => x.packageId === el.id)?.description || el.description,
                }
            });
            if (content.plansOrder) {
                const plansOrderArray = JSON.parse(content.plansOrder);
                const customSort = (a: any, b: any) => {
                    const indexA = plansOrderArray.indexOf(a.id);
                    const indexB = plansOrderArray.indexOf(b.id);
                    return indexA - indexB;
                };
                setPlansItems(changePackageItems.sort(customSort));
            } else {
                setPlansItems(changePackageItems);
            }

        }
    }, [packages]);

    return (
        <section className={styles.section}>
            <div className={"container"}>
                <SectionTitle text={t("Plans")}/>
                <SectionSubtitle text={content.plansDescription}/>
                <div className={styles.wrapper}>
                    {
                        plansItems.map(el => {
                            return (
                                <PlanItem key={el.id} item={el}/>
                            )
                        })
                    }
                </div>

            </div>
            <div className={styles.linkWrapper}>
                <Link className={styles.link} to={"/plans"}>{t("SeeAllPlans")}<img src={arrowRight} alt={"move"}/></Link>
            </div>

        </section>
    )
}

export default PlansSection;